// externals
import { Reducer } from 'redux';

// actions
import { Actions } from './actions';
// interfaces
import { ILeadform } from '../types/ILeadform';
import { USPSCityStateZip } from '@makemydeal/dr-activities-common';

export const initialState: ILeadform = {
    isModalOpen: false,
    title: '',
    description: '',
    successAction: '',
    errorDescription: '',
    externalErrorCount: 0,
    skipLink: false,
    leadFormSubmittedSuccess: false,
    leadFormSubmitting: false,
    leadFormSubmittedFailure: false,
    leadFormReinitialized: false,
    ccpaShown: false,
    currentZip: '',
    dealerZip: '',
    isCCPAEnabled: false,
    zipCodeLoading: false,
    zipCodeFailure: false
};

export const reducer: Reducer<ILeadform> = (state: ILeadform = initialState, action: any) => {
    const { payload, type } = action;

    switch (type) {
        case Actions.OPEN_LEAD_FORM_MODAL: {
            return { ...state, ...payload, isModalOpen: true };
        }
        case Actions.CLOSE_LEAD_FORM_MODAL: {
            return {
                ...state,
                ...payload,
                isModalOpen: false,
                externalErrorCount: 0,
                successAction: '',
                leadFormSubmitting: false
            };
        }
        case Actions.SET_LEAD_FORM_MODAL_ERROR: {
            return { ...state, ...payload, externalErrorCount: state.externalErrorCount += 1, leadFormSubmitting: false };
        }
        case Actions.LEAD_FORM_SUBMITTED:
        case Actions.OFFER_SUBMISSION_REQUEST: {
            return {
                ...state,
                ...{
                    leadFormSubmitting: true
                }
            };
        }
        case Actions.LEAD_FORM_SUBMISSION_SUCCESS:
        case Actions.OFFER_SUBMISSION_SUCCESS: {
            return {
                ...state,
                ...{
                    leadFormSubmittedSuccess: true,
                    leadFormSubmitting: false,
                    leadFormSubmittedFailure: false,
                    leadFormReinitialized: false
                }
            };
        }
        case Actions.LEAD_FORM_SUBMISSION_FAILURE:
        case Actions.OFFER_SUBMISSION_FAILURE: {
            return {
                ...state,
                ...{
                    leadFormSubmittedSuccess: false,
                    leadFormSubmitting: false,
                    leadFormSubmittedFailure: true,
                    leadFormReinitialized: false
                }
            };
        }
        case Actions.REINITIALIZE_LEAD_FORM: {
            return {
                ...state,
                ...{
                    leadFormSubmittedSuccess: false,
                    leadFormSubmitting: false,
                    leadFormSubmittedFailure: false,
                    leadFormReinitialized: true
                }
            };
        }
        case Actions.INIT_SUCCESS: {
            const dealer = action.payload.dealer || {};
            const offer = action.payload.offer || {};
            const hasBeenSent = offer.hasBeenSent || false;
            return {
                ...state,
                leadFormSubmittedSuccess: hasBeenSent,
                dealerZip: dealer.address?.zip,
                isCCPAEnabled: !!dealer.isCCPAEnabled
            };
        }

        case Actions.USPS_ZIP_REQUEST: {
            return {
                ...state,
                zipCodeLoading: true,
                zipCodeFailure: false
            };
        }
        case Actions.USPS_ZIP_SUCCESS: {
            const zipResultsArray: USPSCityStateZip[] = action.payload;
            const ccpaShown = zipResultsArray.filter((zipResult: USPSCityStateZip) => zipResult.state === 'CA').length > 0;

            return {
                ...state,
                ccpaShown,
                zipCodeLoading: false
            };
        }
        case Actions.USPS_ZIP_FAILURE: {
            return {
                ...state,
                zipCodeLoading: false,
                zipCodeFailure: true
            };
        }
        default: {
            return state;
        }
    }
};
